import React from 'react';

import { useAuth } from '../../context/AuthContext';

interface HeaderProps {
  className?: string;
  children?: React.ReactNode;
}

// components/user/Header: ユーザ向け画面共通ヘッダー (Figma node 479-65050)
// 背景 rgba(195,68,22,0.3) / タイトル 20px White / 高さ 60px
// 既存グローバル Header とは目的を分離 (ユーザ個別表示用)
export const Header: React.FC<HeaderProps> = ({ className, children }) => {
  const { user, signOut } = useAuth();

  return (
    <header
      aria-label="ユーザーヘッダー"
      className={[
        'w-full min-w-[320px] h-[60px]',
        'px-[50px] py-[11px] box-border',
        'flex items-center justify-between gap-[10px]',
        'bg-[rgba(195,68,22,0.3)]',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="flex items-center">
        <p className="font-medium text-[20px] leading-none text-white select-none">
          SAS オンライン
        </p>
      </div>
      <div className="flex items-center gap-3">
        {children}
        {user && (
          <>
            <div className="bg-white flex items-center justify-center rounded-full w-10 h-10 shadow-sm">
              <img
                src="/figma_asset/UserGray.svg"
                alt="ユーザーアイコン"
                className="w-6 h-6"
                loading="lazy"
              />
            </div>
            <p className="font-sans text-[16px] text-black leading-none">{user.username}</p>
            <button
              onClick={signOut}
              className="ml-2 px-3 py-1 bg-white text-[#c34416] rounded hover:bg-gray-100 text-sm"
            >
              ログアウト
            </button>
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
